import { useCallback, useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';
//Функция нужна, чтобы на айфоне крутился user-location-marker
export function requestPermissionForOrientation() {
    const parser = new UAParser().getResult();
    if (parser.os.name === 'iOS') {
        if (typeof DeviceOrientationEvent !== 'function')
            return;
        if (typeof DeviceOrientationEvent.requestPermission() !== 'function')
            return;
        DeviceOrientationEvent
            .requestPermission()
            .then((response) => {
            if (response !== 'granted')
                return;
        })
            .catch(console.error);
    }
}
let event_name = 'deviceorientation';
if ('ondeviceorientationabsolute' in window) {
    event_name = 'deviceorientationabsolute';
}
export function useCompass() {
    const [heading, setHeading] = useState(null);
    const getAlpha = useCallback((event) => {
        if ('webkitCompassHeading' in event) {
            setHeading(event.webkitCompassHeading ?? null);
        }
        else {
            setHeading(event.alpha != null ? -event.alpha : null);
        }
    }, []);
    useEffect(() => {
        window.addEventListener(event_name, getAlpha);
        return () => {
            window.removeEventListener(event_name, getAlpha);
        };
    }, [event_name, getAlpha]);
    return heading;
}
